// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2IlHK","infoBtn":"quickbooks_infoBtn__1YtI-","formBox":"quickbooks_formBox__1c4pl","formFooter":"quickbooks_formFooter__2u2Ag"};